import styles from '@styles/screens/StartDemoScreen.module.css'
import { isMobile } from 'react-device-detect';
import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/Qontact.svg';
import { ReactComponent as QontactBackgroundSVG } from '@assets/SVGs/GeneralUse/QontactBackground.svg';
import { VerticalContainer } from './General/Containers';
import designSystem from '@styles/designSystem';

export const QontactLogoPanel: React.FC = () => {
    return (
        <VerticalContainer 
            width={'100%'}
            height={'100%'}
            alignment={'center'}
            backgroundColor={designSystem.colorMainAction}
        >
            <QontactBackgroundSVG 
                viewBox={isMobile ? "0 0 700 305" : "0 0 700 1050"} 
                className={styles['qontact-background']}
                style={{ pointerEvents: 'none' }}
            />
            <div style={{
                width: '300px',   
                height: '100%',
                alignContent: 'center'
            }}>
                <QontactTextSVG/>
            </div>

        </VerticalContainer>
    )
}